import {
  Box,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate, useLocation } from 'react-router-dom';

/* ------------------------------------------------------------------ */
/* MOCK DATA */
/* ------------------------------------------------------------------ */

const rows = [
  {
    id: 1,
    name: 'La Liga Spain',
    abbr: 'ESPLL',
    federation: 'Opta Football',
   
  },
  {
    id: 2,
    name: 'Serie A Italy',
    abbr: 'ITASA',
    federation: 'Opta Football',
   
  },
  {
    id: 3,
    name: 'Ligue 1 France',
    abbr: 'FRAL1',
    federation: 'Opta Football',
   
  },
  {
    id: 4,
    name: 'Bundesliga Germany',
    abbr: 'GERBL',
    federation: 'Opta Football',
   
  },
];

/* ------------------------------------------------------------------ */
/* COMPONENT */
/* ------------------------------------------------------------------ */

export default function AdminPortalCompetitonPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const title = location.state?.title || 'Competitions';

  /* ---------------- ROW HANDLER ---------------- */

  const handleManageCompetition = (row) => {
    navigate(
      `/dashboard/admin-portal/competitions/${row.id}/seasons`,
      {
        state: { competitionName: row.name },
      }
    );
  };

  /* ---------------- COLUMNS ---------------- */

  const columns = [
    { field: 'name', headerName: 'NAME', flex: 1 },
    { field: 'abbr', headerName: 'ABBREVIATION', width: 160 },
    { field: 'federation', headerName: 'FEDERATION', width: 200 },
    // {
    //   field: 'hasTournaments',
    //   headerName: 'HAS TOURNAMENTS',
    //   width: 180,
    //   type: 'boolean',
    // },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      width: 200,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Button
          size="small"
          variant="contained"
          sx={{
            backgroundColor: '#ffffff',
            color: '#000',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#e7e7e736',
            },
          }}
          onClick={() => handleManageCompetition(params.row)}
        >
          Select
        </Button>
      ),
    },
  ];

  return (
    <Box
      sx={{
        border: '1px solid #fff',
        borderRadius: 1,
        p: 2,
        backgroundColor: '#1c1c1c',
      }}
    >
      {/* HEADER */}
    {/* HEADER */}
<Box sx={{ mb: 2 }}>
  {/* ROW 1: BACK ARROW (FULL WIDTH) */}
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      mb: 1,
    }}
  >
    <IconButton
      onClick={() => navigate('/dashboard/admin-portal')}
      sx={{ color: '#fff' }}
    >
      <ArrowBackIcon />
    </IconButton>
  </Box>

  {/* ROW 2: TITLE + ADD BUTTON */}
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <Typography
      sx={{
        color: '#fff',
        fontSize: 18,
        fontWeight: 600,
      }}
    >
      {title}
    </Typography>

    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      sx={{
        color: '#fff',
        borderColor: '#fff',
        textTransform: 'uppercase',
        fontSize: 12,
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.08)',
          borderColor: '#aaa',
        },
      }}
    >
      Add Competition
    </Button>
  </Box>
</Box>

      {/* GRID */}
      <Box sx={{ height: 420 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableRowSelectionOnClick
          pageSizeOptions={[5, 10]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 5, page: 0 },
            },
          }}
          sx={{
            border: 'none',
            color: '#fff',
            backgroundColor: '#111',

            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#1a1a1a',
              borderBottom: '1px solid #333',
            },
            '& .MuiDataGrid-row': {
              borderBottom: '1px solid #333',
            },
            '& .MuiDataGrid-footerContainer': {
              borderTop: '1px solid #333',
            },
          }}
        />
      </Box>
    </Box>
  );
}
